import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { graphql, compose } from 'react-apollo';
import { connect } from 'react-redux';
import { FormattedMessage, injectIntl } from 'react-intl';
import cx from 'classnames';
import s from './PopularLocation.css';
import l from '../../Skeleton/Skeleton.css'
//Components
import PopularLocationSlider from '../PopularLocationSlider';
import JsonLd from '../../SEO/JsonLd';
// Skeleton Loader
import Shimmer from "../../Skeleton/Shimmer";
import HomePopularSkeleton from "../../Skeleton/HomePopularSkeleton";
// Graphql
import getPopularLocationQuery from './getPopularLocation.graphql';
// Locale
import messages from '../../../locale/messages';
// Redux
import { getActiveCategory } from '../../../reducers/category';

class PopularLocation extends React.Component {

  static propTypes = {
    getPopularLocationData: PropTypes.shape({
      loading: PropTypes.bool,
      getPopularLocationAdmin: PropTypes.array
    }),
    activeCategory: PropTypes.string
  };

  static defaultProps = {
    getPopularLocationData: {
      loading: true
    }
  }

  componentDidUpdate(prevProps) {
    const { activeCategory, getPopularLocationData } = this.props;

    // Refetch when activeCategory changes
    if (prevProps.activeCategory !== activeCategory && getPopularLocationData && getPopularLocationData.refetch) {
      getPopularLocationData.refetch({
        categoryType: activeCategory || 'boat'
      });
    }
  }

  render() {
    const { getPopularLocationData, activeCategory } = this.props;

    // SEO: Generate Place Schema for popular locations (like Booking.com)
    const locations = getPopularLocationData?.getPopularLocationAdmin || [];
    const categoryLabel = activeCategory === 'posada' ? 'Posadas' : activeCategory === 'experience' ? 'Experiencias' : 'Botes';
    const placesSchema = locations.length > 0 ? {
      "@context": "https://schema.org",
      "@type": "ItemList",
      "name": `Destinos Populares para Alquiler de ${categoryLabel}`,
      "description": `Los destinos más populares para alquilar ${categoryLabel.toLowerCase()} en Navega`,
      "numberOfItems": locations.length,
      "itemListElement": locations.map((item, index) => ({
        "@type": "ListItem",
        "position": index + 1,
        "item": {
          "@type": "Place",
          "name": item.location,
          "description": item.locationAddress || `Alquiler de ${categoryLabel.toLowerCase()} en ${item.location}`,
          "url": `https://www.navegaapp.com/es/s?address=${encodeURIComponent(item.location)}`,
          "image": item.image ? `https://www.navegaapp.com/images/popularLocation/${item.image}` : undefined
        }
      }))
    } : null;

    return (
      <>
        {getPopularLocationData?.loading ? (<div className={cx('bgBlackTwo')}>
          <div className={s.container}>
            <div className={cx(l.popularSkeletonTwoTitle, 'bgBlackTwo')}>
              <Shimmer />
            </div>
            <div className={s.displayGridTwo}>
              {[1, 2, 3, 4, 5, 6].map((n) => (
                <HomePopularSkeleton key={n} />
              ))}
            </div>
          </div>
        </div>
        ) : (
          getPopularLocationData?.getPopularLocationAdmin?.length > 0 &&
          <div className={s.topBottomCss}>
            {/* SEO: Place Schema for popular destinations */}
            {placesSchema && <JsonLd data={placesSchema} />}
            <div className={s.container}>
              <h3 className={cx(s.containerTitle)}>
                <FormattedMessage {...messages.popularLocation} />
              </h3>
              <PopularLocationSlider data={getPopularLocationData.getPopularLocationAdmin} activeCategory={activeCategory} />
            </div>
          </div>
        )}
      </>
    )
  }
}

const mapState = (state) => ({
  activeCategory: getActiveCategory(state)
});

export default compose(
  injectIntl,
  withStyles(s, l),
  connect(mapState),
  graphql(getPopularLocationQuery, {
    name: 'getPopularLocationData',
    options: (props) => ({
      variables: {
        categoryType: props.activeCategory || 'boat'
      },
      ssr: false
    })
  }),
)(PopularLocation);

